'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.glsLocation = exports.getAddressRequirements = undefined;

var _sagaTools = require('@classpass/saga-tools');

var _Location = require('derivers/Location');

var _Location2 = _interopRequireDefault(_Location);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEY = 'SAGA.API.GLS';
var DEFAULT_LOCALE_INFO = {
  address_fields: {
    address_line_1: 'REQUIRED',
    address_line_2: 'OPTIONAL',
    city: 'REQUIRED',
    postal_code: 'REQUIRED',
    state_code: 'REQUIRED'
  }
};

var getAddressRequirements = exports.getAddressRequirements = (0, _sagaTools.makeEntityScaffold)(KEY + '.GET_LOCALE_INFO', function (client, countryShortCode) {
  return client.gls.getLocaleInfo(countryShortCode).then(function (data) {
    return _Location2.default.addressRequirements(data);
  }).catch(function () {
    return _Location2.default.addressRequirements(DEFAULT_LOCALE_INFO);
  });
}, { defaultKey: [1] });

var glsLocation = exports.glsLocation = (0, _sagaTools.makeEntityScaffold)(KEY + '.GLS_USER_LOCATION', function (client, latitude, longitude) {
  return client.gls.getUserLocationV2({ latitude: latitude, longitude: longitude });
}, { defaultKey: [1, 2] });